import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default function Paypal({ orderData, totalAmount }) {
  const paypal = useRef();
  const user = useSelector(state => state?.user?.user);

  useEffect(() => {
    // Don't render PayPal if user email is not available
    if (!user?.email) {
      console.warn("User email not available for PayPal");
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://www.paypal.com/sdk/js?client-id=AX_OMRZNgI-83_96F4Gt9zDlJIBv2xmrM0GDMYuhfhmFKUHKSS8FKrH1yJNHmQUcVnPlmLSLlRoX1PD9&currency=USD";
    script.async = true;
    script.onload = () => {
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              intent: "CAPTURE",
              purchase_units: [
                {
                  payee: { email_address: user.email },
                  description: orderData?.description || "Order Payment", 
                  amount: {
                    currency_code: "USD",
                    value: totalAmount, 
                  },
                },
              ],
            });
          },
          onApprove: async (data, actions) => {
            try {
              const order = await actions.order.capture();
              console.log("Payment successful:", order);

              const response = await fetch("https://your-api.com/payments", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  transactionId: order.id,
                  email: user.email,
                  status: "Paid",
                  payeeEmail: user.email,
                  amount: order.purchase_units[0].amount.value,
                  currency: order.purchase_units[0].amount.currency_code,
                  paymentMethod: "PayPal",
                  orderDetails: orderData, 
                }),
              });

              const result = await response.json();
              console.log("Payment recorded:", result);
            } catch (error) {
              console.error("Error processing payment:", error);
            }
          },
          onError: (err) => {
            console.error("Payment error:", err);
          },
        })
        .render(paypal.current);
    };
    document.body.appendChild(script);

    // Cleanup function to remove script when component unmounts or dependencies change
    return () => {
      if (script.parentNode) {
        document.body.removeChild(script);
      }
    };
  }, [orderData, totalAmount, user?.email]); // Added user?.email to dependencies

  return <div ref={paypal}></div>;
}